const _ = require('lodash');
const { WIDGET_TYPE } = require('../../dashboardView/constants');
const UserActionRequiredException = require('../../exceptions/UserActionRequiredException');

function getMetricsFromWidget({ widget, customMetrics }) {
  const rawMetrics = [];
  if (widget?.columns && Array.isArray(widget?.columns)) {
    rawMetrics.push(...widget.columns);
  }
  if (widget?.selectedMetric) {
    rawMetrics.push(widget.selectedMetric);
  }
  if (rawMetrics.length === 0 && widget?.metric) {
    rawMetrics.push(widget.metric);
  }
  if (rawMetrics.length === 0 && widget?.childWidgets && Array.isArray(widget?.childWidgets)) {
    widget.childWidgets.forEach(childWidget => {
      if (childWidget.metric) {
        rawMetrics.push(childWidget.metric);
      }
    });
  }

  if (widget?.type === WIDGET_TYPE.goal && widget?.childWidgets && Array.isArray(widget?.childWidgets)) {
    widget.childWidgets.forEach(childWidget => {
      const { goalInfo } = childWidget;
      if (goalInfo && goalInfo.metric) {
        rawMetrics.push(goalInfo.metric);
      }
    });
  }

  if (widget?.type === WIDGET_TYPE.creative && widget?.sort) {
    if (!widget.sort.name) {
      // throw new UserActionRequiredException('Sorting Field Missing', 'SORT_FIELD_MISSING');
      rawMetrics.push('ctr');
    } else {
      rawMetrics.push(widget.sort.name);
    }
  }

  if (widget?.selectedGraphType === 'combo_chart' && widget?.comboChart) {
    Object.values(widget.comboChart)
      .filter(({ metric = undefined }) => Boolean(metric))
      .map(({ metric }) => metric)
      .forEach(({ metric }) => rawMetrics.push(metric));
  }

  const hasXAxisGraphType = ['scatter', 'color_clustering', 'emoji_analysis'];
  if (hasXAxisGraphType.includes(widget?.selectedGraphType)) {
    rawMetrics.push(widget.selectedxAxis, widget.selectedMetric);
  }

  const metrics = _.uniq(rawMetrics);
  const originalMetrics = [];
  const customMetricsByKey = _.keyBy(customMetrics, 'key');

  metrics.filter(Boolean).forEach(metric => {
    if (metric.startsWith('custom-metric:')) {
      originalMetrics.push(...getMetricInCustomMetric(metric, customMetricsByKey));
    } else {
      originalMetrics.push(metric);
    }
  });

  return { metrics: _.uniq(originalMetrics), rawMetrics: metrics };
}

function getMetricInCustomMetric(metric, customMetricsByKey) {
  const metrics = [];
  const thisCustomMetric = customMetricsByKey[metric];
  if (thisCustomMetric?.details && Array.isArray(thisCustomMetric?.details)) {
    const customMetrics = [];
    for (const details of thisCustomMetric.details) {
      for (const metric of details.metrics) {
        if (metric.startsWith('custom-metric:')) {
          customMetrics.push(metric);
        } else {
          metrics.push(metric);
        }
      }
    }
    for (const customMetric of customMetrics) {
      metrics.push(...getMetricInCustomMetric(customMetric, customMetricsByKey));
    }
  }
  return metrics;
}

module.exports = {
  getMetricsFromWidget,
};
